export const FILTER_DEFINITIONS = {

   //👉 para un input de nombre (name) igual a "text" que haga busqueda en varios campos del objeto  
  text: {
    fields: ["dni", "fullName", "phoneNumber", "email",],
  },


  // OPCIONAL

  //👉 Para inputs individuales de nombre (name) igual a "name o dni o province, etc"
  name: {
    fields: ["name"],
  },
  dni: {
    fields: ["dni"],
  },

  // En caso de que el valor venga anidado 
  province: {
    fields: ["address.province"],
  }
}